/* Bundle Builder page presentation layer (21.10.2026). Watches the builder's own renders and adds presentation only;
   it never changes the kit, prices, stock or compatibility. The builder rebuilds its panel and kit list on every
   change (replaceChildren), so this layer remembers what it has already shown:
   - a real step change deals the step's tiles and cards in (not every re-render);
   - a kit line that was not in the kit before stamps in, with its letter tag;
   - the summary docket gets the red "Checked / All compatible" stamp only while the builder's own Add kit button is
     enabled (a valid kit), thumping in once per kit. Reduced motion: no motion, the stamp still shows. */
(() => {
  'use strict';
  if (window.CgauBundleFx) return;
  window.CgauBundleFx = true;

  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const DEAL = '.cgb-tile, .cgb-card, .cgb-sumline, .cgb-success__art, .cgb-cov li';

  const bind = (app) => {
    if (!app || app.dataset.cgbFx) return;
    const panel = app.querySelector('[data-panel]');
    const side = app.querySelector('[data-side]');
    if (!panel || !side) return;
    app.dataset.cgbFx = '1';
    let lastView = null;
    let known = null;
    let stamped = '';

    const view = () => {
      const step = app.querySelector('[data-stepper] [aria-current="step"]')?.dataset.v || '';
      return step + (panel.querySelector('.cgb-success') ? ':success' : '');
    };
    const lineId = (li) => li.querySelector('[data-act="remove"]')?.dataset.v || '';
    const kitSignature = () => [...side.querySelectorAll('.cgb-kitline')]
      .map((li) => lineId(li) + 'x' + (li.querySelector('.cgb-qty span')?.textContent || '')).join(',');

    const stampDocket = (body) => {
      const docket = body.querySelector('.cgb-docket');
      const add = body.querySelector('.cgb-sumactions [data-act="add-kit"]');
      if (!docket || !add || add.disabled || docket.querySelector('.cgb-fx-stamp')) return;
      const stamp = document.createElement('div');
      stamp.className = 'cgb-fx-stamp';
      stamp.setAttribute('aria-hidden', 'true');
      stamp.innerHTML = '<span>Checked</span><small>All compatible</small>';
      const sig = kitSignature();
      if (sig !== stamped && !reduced.matches) stamp.classList.add('is-new');
      stamped = sig;
      docket.append(stamp);
    };

    const onPanel = () => {
      const body = panel.firstElementChild;
      if (!body) return;
      const now = view();
      if (now !== lastView) {
        lastView = now;
        if (!reduced.matches) {
          [...body.querySelectorAll(DEAL)].slice(0, 14).forEach((el, i) => {
            el.classList.add('cgb-fx-card');
            el.style.setProperty('--cgb-i', String(i));
          });
        }
      }
      stampDocket(body);
    };

    const onSide = () => {
      if (!side.querySelector('.cgb-side__title')) return;
      const lines = [...side.querySelectorAll('.cgb-kitline')];
      const ids = lines.map(lineId).filter(Boolean);
      if (known === null) known = new Set();
      if (!reduced.matches) {
        let n = 0;
        lines.forEach((li) => {
          const id = lineId(li);
          if (id && !known.has(id)) { li.classList.add('cgb-fx-new'); li.style.setProperty('--cgb-i', String(n++)); }
        });
      }
      known = new Set(ids);
      // The docket's stamp depends on the kit too: re-check after the kit list changes.
      const body = panel.firstElementChild;
      if (body) stampDocket(body);
    };

    new MutationObserver(onPanel).observe(panel, {childList: true});
    new MutationObserver(onSide).observe(side, {childList: true});
    onPanel();
    onSide();
  };

  const boot = () => document.querySelectorAll('cgau-bundle-builder').forEach(bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true});
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
